import React from 'react';
import { THEME } from '../../utils/theme';

const STATUS_OPTIONS = [
  { value: 'played', label: 'Played', color: THEME.success },
  { value: 'shelved', label: 'Shelved', color: THEME.textSecondary },
  { value: 'wtp', label: 'WTP', color: THEME.warning },
  { value: 'wtf', label: 'WTF', color: THEME.pink },
  { value: 'never', label: 'Never', color: THEME.danger },
];

const BulkActions = ({ selectedCount, onBulkStatus, onClearSelection }) => {
  if (selectedCount === 0) return null;
  return (
    <div style={{ position: 'fixed', bottom: '28px', left: '50%', transform: 'translateX(-50%)', background: THEME.bgElevated, border: `1px solid ${THEME.border}`, borderRadius: '14px', padding: '14px 22px', display: 'flex', alignItems: 'center', gap: '14px', zIndex: 100, boxShadow: `0 12px 40px ${THEME.shadowHeavy}`, animation: 'slideUp 0.2s ease' }}>
      <span style={{ color: THEME.text, fontWeight: '600', fontSize: '14px' }}>{selectedCount} selected</span>
      <select onChange={e => { if (e.target.value) { onBulkStatus(e.target.value); e.target.value = ''; }}} defaultValue="" style={{ background: THEME.bg, color: THEME.text, border: `1px solid ${THEME.border}`, borderRadius: '8px', padding: '10px 14px', cursor: 'pointer', fontSize: '13px' }}>
        <option value="" disabled>Set Status...</option>
        {STATUS_OPTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
      </select>
      <button onClick={onClearSelection} style={{ background: THEME.bgHover, color: THEME.textMuted, border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontSize: '16px' }}>&times;</button>
    </div>
  );
};

export default BulkActions;
